module.exports = "https://assets.niwcorp.com/_next/static/images/ico-fb-f7575f066ea198ce35fab6f142621c13.svg";